export default {
    methods: {
        isFormFieldValid (field) {
            if (typeof this.$page.props.errors[field] !== 'undefined') {
                return false
            }

            return null
        }
    }
}
